import { Component, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValuesAccessorBase } from '../custom-control/ValueAccesorBase';

@Component({
  selector: 'app-text-box-login',
  templateUrl: './text-box-login.component.html',
  styleUrls: ['./text-box-login.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: TextBoxLoginComponent,
    multi: true
  }]
})
export class TextBoxLoginComponent extends ValuesAccessorBase<string> implements OnInit {

  @Input() label: string;
  @Input() obrigatorio: Boolean;
  @Input() placeholder: '';
  @Input() name: string;
  @Input() maxLength: Number;
  @Input() mascara: any;

  ngOnInit() {
  }

}
